import { FC, useEffect, useState } from 'react'
import * as Yup from 'yup'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import { Adapter, IFormSeason, SeasonDto, SeasonRequestDto, SeasonService, SeasonStatusEnum } from '../../modules/core'
import { catchErrorMsg } from '../../modules/core/helpers/Helper'
import { toast } from 'react-toastify'
import { useNavigate, useParams } from 'react-router-dom'
import { FormCheckBox, FormDataPicker, FormRadio } from 'app/components'
import { PageTitle } from '_metronic/layout/core'
import { RootState } from 'setup'
import { shallowEqual, useSelector } from 'react-redux'
import moment from 'moment'
type Props = {

}

export const SeasonSettingEditPage: FC<Props> = () => {

  let initValue: IFormSeason = {
    title: '',
    status: SeasonStatusEnum[SeasonStatusEnum.New],
    periodStart: new Date(),
    periodEnd: new Date(),
    expiredDate: new Date()
  }
  const formSchema = Yup.object().shape({
    title: Yup.string().required('require'),
    periodStart: Yup.date().required('require'),
    periodEnd: Yup.date().required('require'),
    expiredDate: Yup.date().required('require'),
  })


  const [loading, setLoading] = useState(true)
  const [data, setData] = useState<IFormSeason>(initValue)

  const { id } = useParams()
  const navigate = useNavigate()
  useEffect(() => {
    const init = () => {
      if (id && id !== 'new') {

        SeasonService.GetById(Number(id)).then((result) => {
          const res = result.data.result
          if (res) {
            const frmDto = Adapter.FormSeason(res);
            setData(frmDto)
          }
        })
      }
      setLoading(false)
    }
    init()
  }, [id])

  const onSubmit = async (values: IFormSeason) => {
    setLoading(true)
    const updatedData = Adapter.mapSeason(values)

    if (id && id === 'new') {
      Save(updatedData)
    } else if (id) {
      Update(Number(id), updatedData)
    }


  }

  const Save = (updatedData: SeasonRequestDto) => {

    SeasonService.Create(updatedData)
      .then((res) => {
        toast.success('Save Success.')
        setLoading(false)
        navigate('/setting/seasons')
      }).catch((res) => {
        toast.error(catchErrorMsg(res))
        setLoading(false)
      })
  }

  const Update = (id: number, updatedData: SeasonRequestDto) => {

    SeasonService.Update(id, updatedData).then(() => {
      toast.success('Update Success.')
      setLoading(false)
      navigate('/setting/seasons')
    }).catch((res) => {
      toast.error(catchErrorMsg(res))
      setLoading(false)
    })
  }

  const CellStyle: React.FC<{ lable: string, children?: React.ReactNode, labelCls?: string, inputCls?: string, txtEndCls?: string, textEnd?: string }> = (props) => {
    const labelCls = props.labelCls ?? 'col-lg-4 fw-bold'
    const inputCls = props.inputCls ?? 'col-lg-4'
    return (
      <div className='row mb-7'>
        <label className={labelCls}>{props.lable}</label>
        <div className={inputCls}>
          <span className='fw-bolder fs-6 text-dark'>{props.children}</span>

        </div>
        {props.textEnd && <div className={props.txtEndCls}>
          <span > {props.textEnd}</span>
        </div>}
      </div>
    )
  }


  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Setting',
            path: 'setting',
            isSeparator: false,
            isActive: false,
          }
        ]}
      >
        Season
      </PageTitle>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header cursor-pointer'>
          <div className='card-title m-0 '>
            <h3 className='fw-bolder py-2'>Season</h3>

          </div>
        </div>
        <Formik
          enableReinitialize
          initialValues={data}
          validationSchema={formSchema}
          onSubmit={onSubmit}
          validate={(v) => console.log(v)}
        >
          {({ values, handleSubmit, setFieldValue, errors, touched }) => (
            <Form>
              <>
                {/* begin::Scroll */}
                <div className='card-body p-9'>
                  <CellStyle lable='ชื่อ'>
                    <Field
                      name='title'
                      className={
                        'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                        (errors.title && touched.title ? ' is-invalid' : '')
                      }
                    />
                    <ErrorMessage name={`title`} component='div' className='text-danger' />
                  </CellStyle>
                  <CellStyle lable='วันเริ่ม'>
                    <Field
                      name='periodStart'
                      className={
                        'form-control form-control-solid' +
                        (errors.periodStart && touched.periodStart ? ' is-invalid' : '')
                      }
                      value={moment(values.periodStart).format('DD/MM/YYYY')}
                      onDateChange={(value: Date, e: any) => {
                        setFieldValue('periodStart', value)
                        if (values.periodEnd < value) {
                          setFieldValue('periodEnd', value)
                        }
                      }}                    
                      component={FormDataPicker}
                    />
                    <ErrorMessage name={`periodStart`} component='div' className='text-danger' />
                  </CellStyle>
                  <CellStyle lable='วันสิ้นสุด'>
                    <Field
                      name='periodEnd'
                      className={
                        'form-control form-control-solid' +
                        (errors.periodEnd && touched.periodEnd ? ' is-invalid' : '')
                      }
                      value={moment(values.periodEnd).format('DD/MM/YYYY')}
                      onDateChange={(value: Date, e: any) => {
                        setFieldValue('periodEnd', value)
                      }}
                      minDate={values.periodStart}
                      component={FormDataPicker}
                    />
                    <ErrorMessage name={`periodEnd`} component='div' className='text-danger' />
                  </CellStyle>

                  <CellStyle lable='วันหมดเขต'>
                    <Field
                      name='expiredDate'
                      className={
                        'form-control form-control-solid' +
                        (errors.expiredDate && touched.expiredDate ? ' is-invalid' : '')
                      }
                      value={moment(values.expiredDate).format('DD/MM/YYYY')}
                      onDateChange={(value: Date, e: any) => {
                        setFieldValue('expiredDate', value)
                      }}
                    
                      component={FormDataPicker}
                    />
                    <ErrorMessage name={`ExpiredDate`} component='div' className='text-danger' />
                  </CellStyle>

                  <CellStyle lable='สถานะ'>
                    <div className='d-flex justify-content-between'>
                      <Field
                        label={SeasonStatusEnum[SeasonStatusEnum.New]}
                        name={`status`}
                        gName={`status`}
                        gValue={SeasonStatusEnum[SeasonStatusEnum.New]}
                        component={FormRadio}

                      />
                      {id && id !== 'new' && <><Field
                        label={SeasonStatusEnum[SeasonStatusEnum.Started]}
                        name={`status`}
                        gName={`status`}
                        gValue={SeasonStatusEnum[SeasonStatusEnum.Started]}
                        component={FormRadio}

                      />
                        <Field
                          label={SeasonStatusEnum[SeasonStatusEnum.Ended]}
                          name={`status`}
                          gName={`status`}
                          gValue={SeasonStatusEnum[SeasonStatusEnum.Ended]}
                          component={FormRadio}
                        />
                         <Field
                          label={SeasonStatusEnum[SeasonStatusEnum.InActive]}
                          name={`status`}
                          gName={`status`}
                          gValue={SeasonStatusEnum[SeasonStatusEnum.InActive]}
                          component={FormRadio}
                        />
                        
                        
                         </>}


                    </div>

                  </CellStyle>

                </div>
                {/* end::Scroll */}

                <div className='card-footer d-flex py-6 px-9'>
                  <button type='submit' className='btn btn-primary pe-5  me-10' disabled={loading}>
                    {!loading && 'Save Changes'}
                    {loading && (
                      <span className='indicator-progress' style={{ display: 'block' }}>
                        Please wait...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>

                  <button className='btn btn-light' onClick={() => navigate('/setting/seasons')}> Back</button>
                </div>
              </>
            </Form>
          )}
        </Formik>
      </div>
    </>
  )
}

